import React from "react";
import styles from "../characteristicCustomForm.module.scss";
import editIcon from "../../../../static/images/edit-icon-blue.png";
import { EDIT } from "../../../../constants";
import { PERMISSIONS } from "../../../../constants/permissions";

export const EditIcon = ({ editable, setEditable, hasPermission, isSignedLocked }) => {
  if (editable) return null;

  const handleEdit = () => {
    setEditable(true);
  };

  return (
    <h2 className={`${styles.tab_content_hdg}`}>
      <button className={`float-sm-right ${styles.tab_edit} handleEdit`} onClick={handleEdit} disabled={!hasPermission(PERMISSIONS.CHARACTERISTIC_CUSTOM_FORM_EDIT) || isSignedLocked}>
        <img src={editIcon} alt="edit" />
        {EDIT}
      </button>
    </h2>
  );
};
